import React, { useCallback, useMemo, useState } from 'react';
import { PageTitleContext } from './usePageTitle';

interface PageChrome {
  title: string;
  helpText?: string;
}

export const PageTitleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [chrome, setChrome] = useState<PageChrome>({ title: '' });
  const setTitle = useCallback(
    (title: string, helpText?: string) => setChrome({ title, helpText }),
    [],
  );
  const value = useMemo(
    () => ({ title: chrome.title, helpText: chrome.helpText, setTitle }),
    [chrome, setTitle],
  );
  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
};
